import React from "react"
import { Box, Typography } from "@mui/material"
import { Toys } from "@mui/icons-material"
import PropTypes from "prop-types"

const styles = {
    root: {
        position: 'absolute',
        zIndex: '2000',
        bottom: '6rem',
        left: '1rem',
        background: 'white',
        borderRadius: '8px',
        boxShadow: '1px 1px 3px #999',
    },
    title: {
        box: {
textAlign: 'center',
fontWeight: 'bold',
padding: '8px',
background: '#eee',
        },
        text: {
            
        }
    },
    items: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
        },
        box: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: "space-between",
            margin: "4px 8px",
        },
        title1: {
            fontSize: "13px",
            width: "200px",
        },
        title2: {
            fontSize: "13px",
            textAlign: "left",
        },
        colorBox: {
            width: "20px",
        },
    }
}

const PruningLegendView = ({open}) => {

    if (!open) { return null }

    return (
        <Box style={styles.root}>
            <Box style={styles.title.box}>
                <Typography style={styles.title.text}>樹冠拡大タイプ</Typography>
            </Box>
            <Box style={styles.items.root}>
                <Box style={styles.items.box}>
                    <Typography style={styles.items.title1}>①-1維持タイプ（樹冠拡大済）</Typography>
                    <Typography style={styles.items.title2}>良好・達成済</Typography>
                    <Box style={{ ...styles.items.colorBox, background: "#1B5E20"}}></Box>
                </Box>
                <Box style={styles.items.box}>
                    <Typography style={styles.items.title1}>①-2維持タイプ（樹冠拡大不可）</Typography>
                    <Typography style={styles.items.title2}>安定・制限あり</Typography>
                    <Box style={{ ...styles.items.colorBox, background: "#00796B"}}></Box>
                </Box>
                <Box style={styles.items.box}>
                    <Typography style={styles.items.title1}>①-3維持タイプ（その他）</Typography>
                    <Typography style={styles.items.title2}>中立維持</Typography>
                    <Box style={{ ...styles.items.colorBox, background: "#1976D2"}}></Box>
                </Box>
                <Box style={styles.items.box}>
                    <Typography style={styles.items.title1}>②縮小タイプ</Typography>
                    <Typography style={styles.items.title2}>ネガティブ変化</Typography>
                    <Box style={{ ...styles.items.colorBox, background: "#F57C00"}}></Box>
                </Box>
                <Box style={styles.items.box}>
                    <Typography style={styles.items.title1}>③拡大タイプ</Typography>
                    <Typography style={styles.items.title2}>ポジティブ成長</Typography>
                    <Box style={{ ...styles.items.colorBox, background: "#43A047" }}></Box>
                </Box>
                <Box style={styles.items.box}>
                    <Typography style={styles.items.title1}>④再生タイプ</Typography>
                    <Typography style={styles.items.title2}>更新・再構築</Typography>
                    <Box style={{ ...styles.items.colorBox, background: "#D32F2F" }}></Box>
                </Box>
            </Box>
        </Box>
    )

}
PruningLegendView.propTypes = {
    open: PropTypes.bool,
}

export default PruningLegendView